module.exports = __webpack_public_path__ + "img/白酒行业数字化转型场景图谱.cb0e125f.jpg";